<template>
  <el-card class="box-card feedback-dashboard" shadow="never">
    <div class="pd-y-5 flex-display ai-center js-between change-display">
      <div class="text-left">
        <p class="text-font-24 mg-less color-primary">แบบประเมินการเรียนออนไลน์</p>
        <p class="text-font-16 mg-less">หลักสูตร {{name}}</p>
      </div>
      <div class="text-right">
        <el-rate
          :value="avg"
          void-color="#FFB800"
          :disabled="true"
          :high-threshold="10"
          class="size-big mg-last-less"
        ></el-rate>
        <p class="text-font-18 mg-less">คะแนนประเมินเฉลี่ย <span class="text-font-30 color-warning ">{{avg.toFixed(1)}}</span> คะแนน</p>
      </div>
    </div>
  </el-card>
</template>

<script>

export default {
  props: {
    name: {
      type: String,
      default() {
        return "";
      },
    },
    avg: {
      type: Number,
      default() {
        return 0;
      },
    },
  }
};
</script>